import { Component, Injector, OnInit } from '@angular/core';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { AppTextService } from '@fi-shared/app-text';
import { CustomerService } from '../../customer-billing-customer/customer.service';
import { IFiHttpPromise } from '@fi-shared/to-fi-promise';
import { CustomerBillingCustomerUnitListData } from '../customer-billing-customer-unit-list-data';
import { CoreParameterModel, ILightWeightObjectCollection } from '@fi-shared/models';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { CustomerBillingCustomerModel } from '../../customer-billing-customer/customer-billing-customer.model';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { FiLocalSearchGroupType } from '@fi-shared/fi-local-search2/fi-local-search-group-type';

@Component({
    selector: 'fi-customer-billing-customer-unit-list',
    template: '<fi-items-list [settings]="ListData"></fi-items-list>',
    styleUrls: ['./customer-billing-customer-unit-list.component.scss'],
    standalone: false,
})
export class CustomerBillingCustomerUnitListComponent
    extends ItemsListContainerBase<CustomerBillingCustomerUnitListData>
    implements OnInit
{
    constructor(
        private customerService: CustomerService,
        private appTextService: AppTextService,
        private injector: Injector,
        private tabsModuleService: TabsModuleService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(() => new CustomerBillingCustomerUnitListData(this.injector), {
            showDelete: false,
        });

        this.tabsModuleService.setTabsSettings({
            listData: this.ListData,
        });
    }

    protected LoadItems(): Promise<void> {
        const self = this;
        return this.customerService.GetCustomerUnits(this.getLoadParameter()).then((response) => {
            const data = response.map(mapCustomerData);
            this.ListData.appendData(data);
        });

        function mapCustomerData(data) {
            const customer = new CustomerBillingCustomerModel(data, self.injector);
            customer.Name = data.BusinessUnitName;

            if (data.ChildItems) customer.ChildItems = data.ChildItems.map(mapCustomerData);

            return customer;
        }
    }

    protected SetItemsCount(): IFiHttpPromise<number> {
        return this.customerService.GetCustomerUnitsCount(this.getLoadParameter());
    }

    protected InitializeLocalSearchData() {
        return this.customerService.GetObjectsForCustomerUnitsLocalSearch().then((lightWeightObjectCollection) => {
            this.ListData.raiseLightWeightObjectCollectionChanged(lightWeightObjectCollection);
        });
    }

    private getLoadParameter() {
        const parameterModel = new CoreParameterModel();
        Object.assign(parameterModel, this.ListData.getFilterParams());

        Object.assign(parameterModel, this.ListData.getOffsetParams());

        parameterModel.SelectedSort = {
            ColumnName: this.ListData.Sort.Column,
            SortDirection: this.ListData.Sort.Reverse,
        };

        this.ListData.mergeLocalSearchV2Parameter(parameterModel);

        return parameterModel;
    }
}
